import { TurnTranscript } from '@db8/shared'
import { useAblyTypedPubSub } from '../use-ably'
import { useAxios } from '@/contexts/AxiosProvider'

type TranscriptsByStep = Record<number, TurnTranscript[]>

export const useTranscriptsPubSub = ({
  transcriptions,
  setTranscriptions,
  hallId,
}: {
  transcriptions: TranscriptsByStep
  setTranscriptions: (t: any) => void
  hallId?: string
}) => {
  const axios = useAxios()

  const { publish } = useAblyTypedPubSub<TranscriptsByStep>(
    'transcripts',
    ({ data }) => {
      setTranscriptions({})
      setTranscriptions(data)
    },
    hallId && {
      url: `/transcription/transcript/${hallId}`,
    },
  )

  const publishTranscripts = (updated: TranscriptsByStep) => {
    publish(updated)
    void axios.post(`/transcription/transcript/batch`, {
      transcriptions: updated,
      hallId,
    })
  }

  return { publishTranscripts }
}
